'use client';

import { useState } from 'react';

const ENQUIRY_TYPES = ['Sell', 'Acquire', 'Let / Rent', 'Join Key Privé'];

export default function ContactForm() {
  const [enquiryType, setEnquiryType] = useState('Acquire');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <form className="space-y-10" onSubmit={handleSubmit}>
      {/* Enquiry Type */}
      <div>
        <label className="font-body text-xs tracking-[0.2em] uppercase text-kp-stone block mb-4">
          Enquiry Type
        </label>
        <div className="flex flex-wrap gap-3">
          {ENQUIRY_TYPES.map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => setEnquiryType(type)}
              className={`font-body text-xs tracking-[0.15em] uppercase px-5 py-2 border transition-all ${
                enquiryType === type
                  ? 'border-kp-ivory text-kp-ivory bg-kp-ivory/10' :'border-kp-ivory/20 text-kp-ivory/50 hover:border-kp-ivory/40'
              }`}
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* Name */}
      <div>
        <label className="font-body text-xs tracking-[0.2em] uppercase text-kp-stone block mb-2">
          Name
        </label>
        <input
          type="text"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full bg-transparent border-b border-kp-ivory/20 focus:border-kp-ivory text-kp-ivory font-body text-base py-2 outline-none transition-colors placeholder:text-kp-ivory/20"
        />
      </div>

      {/* Email */}
      <div>
        <label className="font-body text-xs tracking-[0.2em] uppercase text-kp-stone block mb-2">
          Email
        </label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border-b border-kp-ivory/20 focus:border-kp-ivory text-kp-ivory font-body text-base py-2 outline-none transition-colors placeholder:text-kp-ivory/20"
        />
      </div>

      {/* Phone */}
      <div>
        <label className="font-body text-xs tracking-[0.2em] uppercase text-kp-stone block mb-2">
          Phone
        </label>
        <input
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full bg-transparent border-b border-kp-ivory/20 focus:border-kp-ivory text-kp-ivory font-body text-base py-2 outline-none transition-colors placeholder:text-kp-ivory/20"
        />
      </div>

      {/* Message */}
      <div>
        <label className="font-body text-xs tracking-[0.2em] uppercase text-kp-stone block mb-2">
          Message
        </label>
        <textarea
          required
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Tell us about your property journey…"
          className="w-full bg-transparent border-b border-kp-ivory/20 focus:border-kp-ivory text-kp-ivory font-body text-base py-2 outline-none transition-colors resize-none placeholder:text-kp-ivory/20"
        />
      </div>

      {/* Submit */}
      <div className="flex justify-center pt-6">
        {submitted ? (
          <div className="text-center">
            <p className="font-display text-2xl text-kp-ivory italic mb-2">Thank you.</p>
            <p className="font-body text-sm text-kp-stone tracking-[0.1em]">We will be in touch shortly.</p>
          </div>
        ) : (
          <button
            type="submit"
            className="w-32 h-32 rounded-full border border-kp-ivory/30 text-kp-ivory font-body text-xs tracking-[0.2em] uppercase hover:bg-kp-ivory hover:text-kp-obsidian transition-all duration-500 flex items-center justify-center"
          >
            Send
          </button>
        )}
      </div>
    </form>
  );
}
